import React from 'react';
import AutoSaveIndicator from '../../../components/common/AutoSaveIndicator';

/**
 * 顶部工具栏：标签名称输入、提交/关闭按钮、自动保存状态与提交反馈
 */
function CreatorToolbar({
  labelName,
  onLabelNameChange,
  onSubmit,
  onClose,
  isSubmitting,
  isEditMode,
  submitFeedback,
  onOpenShare,
  shareLink,
  // 自动保存相关
  autoSaveStatus,
  autoSaveTime,
  autoSaveError,
  onManualSave,
}) {
  return (
    <>
      <div className="creator-toolbar">
        <div className="toolbar-left">
          <label className="toolbar-label">标签名称：</label>
          <input
            type="text"
            placeholder="请输入标签名称"
            value={labelName}
            onChange={(e) => onLabelNameChange(e.target.value)}
            className="toolbar-input"
          />
          {/* 自动保存状态指示器 */}
          {autoSaveStatus && (
            <AutoSaveIndicator
              status={autoSaveStatus}
              lastSavedTime={autoSaveTime}
              error={autoSaveError}
              onClick={onManualSave}
            />
          )}
        </div>
        <div className="toolbar-right">
          <button className="btn-submit" onClick={onSubmit} disabled={isSubmitting}>
            {isSubmitting ? (isEditMode ? '更新中...' : '提交中...') : (isEditMode ? '更新' : '提交')}
          </button>
          <button className="btn-close" onClick={onClose}>关闭</button>
        </div>
      </div>

      {submitFeedback?.message && (
        <div className={`submit-feedback ${submitFeedback.type === 'error' ? 'is-error' : 'is-success'}`}>
          <div style={{ marginBottom: 0 }}>{submitFeedback.message}</div>
          {submitFeedback.type !== 'error' && shareLink && (
            <button className="btn-template" style={{ marginTop: 8 }} onClick={onOpenShare}>
              打开分享弹窗
            </button>
          )}
        </div>
      )}
    </>
  );
}

export default CreatorToolbar;
